import React, { useEffect, useState } from 'react';
import mammoth from 'mammoth';

import "../Terms/styles.css";

const Privacy: React.FC = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/privacy_policy.docx')
      .then(res => res.arrayBuffer())
      .then(arrayBuffer => mammoth.convertToHtml({ arrayBuffer }))
      .then(result => setContent(result.value))
      .catch(err => console.error(err));
  }, []);

  return (
    <div
      className="docx-content prose"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default Privacy;